import React, { useEffect, useMemo, useState } from "react";
import ReactApexChart from "react-apexcharts";
import "./AllCard.css";
import { getContestChartReturn } from "../../../api/contest";

const locale = require("react-redux-i18n").I18n;

const ChartContest = ({ status }) => {
  const [data, setData] = useState();
  const [minValue, setMinValue] = useState(0);
  const contestId = localStorage.getItem("contestId");

  const categories = data?.data.map((item) => item.date) ?? [];
  const seriesData = data?.data.map((item) => item.value) ?? [];

  const fetchContestChart = async () => {
    try {
      const data = await getContestChartReturn({ id: contestId });
      if (data.data?.data?.length > 0) {
        setData(data.data);

        const min = data.data.data.filter(
          (item, index) => index === data.data.data.length - 1
        );
        setMinValue(min[0].value);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchContestChart();
  }, []);

  const chartColor = minValue >= 0 ? "#1CB894" : "#FF4560";

  const options = useMemo(() => {
    return {
      colors: [chartColor],
      chart: {
        height: 350,
        type: "area",
        zoom: {
          enabled: false,
        },
        toolbar: {
          show: false,
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: "smooth",
        colors: [chartColor],
      },
      xaxis: {
        type: "category",
        categories: categories?.map((date) => {
          const d = new Date(date);
          const month = d.toLocaleString("en-US", { month: "short" });
          const day = d.getDate();
          const year = d.getFullYear();
          return `${month} ${day} ${year}`;
        }),
        labels: {
          rotate: 0,
          style: {
            fontSize: "12px",
          },
        },
        tickPlacement: "on",
        axisBorder: {
          show: true,
        },
        axisTicks: {
          show: true,
        },
      },
      yaxis: {
        forceNiceScale: true,
        floating: false,
        decimalsInFloat: 0,
      },
      tooltip: {
        x: {
          show: true,
        },
        y: {
          formatter: function (value) {
            return value.toFixed(2);
          },
        },
      },
      grid: {
        xaxis: {
          lines: {
            show: false,
          },
        },
      },
      fill: {
        type: "gradient",
        gradient: {
          shade: "light",
          type: "vertical",
          shadeIntensity: 0.5,
          gradientToColors: undefined,
          inverseColors: false,
          opacityFrom: 0.7,
          opacityTo: 0.1,
          stops: [0, 90, 100],
          colorStops: [
            {
              offset: 0,
              color: chartColor,
              opacity: 0.7,
            },
            {
              offset: 100,
              color: chartColor,
              opacity: 0.1,
            },
          ],
        },
      },
      plotOptions: {
        area: {
          fillTo: "end",
        },
      },
    };
  }, [minValue, categories]);

  const series = [
    {
      name: "value",
      data: seriesData,
    },
  ];

  return (
    <div
      className="border d-flex p-24 flex-column box-chart-return"
      style={
        status?.status === "upcoming" ||
        data?.data?.length <= 0 ||
        data?.data === undefined
          ? { borderRadius: "8px", height: "377px" }
          : {
              borderRadius: "8px",
            }
      }
    >
      <div className="text-bold text-return" style={{ fontSize: "16px" }}>
        {locale.t("dashboardContest.return_percent")}
      </div>
      {status?.status === "upcoming" ||
      data?.data?.length <= 0 ||
      data?.data === undefined ? (
        <div
          style={{
            color: "#A3A3A3",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
            flexDirection: "column",
          }}
        >
          <img
            src="/assets/images/icons/imageNotFound.png"
            style={{ width: "52px", height: "52px" }}
            alt=""
          />
          <div style={{ fontWeight: "800" }}>
            {locale.t("dashboardContest.title_no_data")}
          </div>
          <div style={{ fontSize: "12px" }}>
            {locale.t("dashboardContest.desc_no_data")}
          </div>
        </div>
      ) : (
        <>
          <div style={{ width: "100%", marginTop: "16" }}>
            {data?.data?.length > 0 && (
              <ReactApexChart
                options={options}
                series={series}
                type="area"
                height={350}
              />
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default ChartContest;
